// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gh-menuLink{font-size:14px;display:flex;justify-content:space-between}.gh-menuLink:hover *{--text-opacity:1;color:#006ed2;color:rgba(0,110,210,var(--text-opacity))}.gh-menuLink .gh-menuIcon .gh-icon{visibility:hidden}.gh-menuLink:hover .gh-menuIcon .gh-icon{visibility:visible}.gh-menuIcon{display:flex;align-items:center}.gh-menuLink h3{font-size:16px}", ""]);
// Exports
module.exports = exports;
